export const getSeasonalTheme = () => {
  const now = new Date();
  const month = now.getMonth() + 1; // Months are 0-indexed
  const day = now.getDate();
  
  // Check for manual theme override (only in browser environment)
  if (typeof localStorage !== 'undefined') {
    const manualTheme = localStorage.getItem('manualTheme');
    if (manualTheme && ['christmas', 'cny', 'spring', 'summer', 'halloween', 'default', 'newyear', 'thaipusam', 'hariRayaAidilfitri', 'labour', 'wesak', 'hariRayaHaji', 'merdeka', 'malaysia', 'deepavali'].includes(manualTheme)) {
      return manualTheme;
    }
  }
  
  // New Year's Day (January 1)
  if (month === 1 && day === 1) {
    return 'newyear';
  }
  // Chinese New Year (typically January/February)
  else if ((month === 1 && day >= 29 && day <= 31) || (month === 2 && day <= 2)) {
    return 'cny';
  }
  // Thaipusam (February 11)
  else if (month === 2 && day === 11) {
    return 'thaipusam';
  }
  // Hari Raya Aidilfitri (Eid al-Fitr) (March 31 - April 2)
  else if ((month === 3 && day === 31) || (month === 4 && day >= 1 && day <= 2)) {
    return 'hariRayaAidilfitri';
  }
  // Labour Day (May 1) and Wesak Day (May 12)
  else if (month === 5 && day === 1) {
    return 'labour';
  } else if (month === 5 && day === 12) {
    return 'wesak';
  }
  // Hari Raya Haji (Eid al-Adha) (June 7)
  else if (month === 6 && day === 7) {
    return 'hariRayaHaji';
  }
  // Merdeka Day (August 31)
  else if (month === 8 && day === 31) {
    return 'merdeka';
  }
  // Malaysia Day (September 16)
  else if (month === 9 && day === 16) {
    return 'malaysia';
  }
  // Deepavali (Diwali) (October 20)
  else if (month === 10 && day === 20) {
    return 'deepavali';
  }
  // Christmas (December 25)
  else if (month === 12 && day === 25) {
    return 'christmas';
  }
  // // Christmas period theme (December 20-31)
  // else if (month === 12 && day >= 20) {
  //   return 'christmas';
  // }
  // // Spring (March-May, excluding specific event days)
  // else if (month >= 3 && month <= 5) {
  //   return 'spring';
  // }
  // // Summer (June-August, excluding specific event days)
  // else if (month >= 6 && month <= 8) {
  //   return 'summer';
  // }
  // // Halloween (October 25-31)
  else if (month === 10 && day >= 25) {
    return 'halloween';
  }
  // Default theme
  else {
    return 'default';
  }
};

export const getThemeColors = (theme) => {
  const themes = {
    default: {
      primary: '#ffffff',
      secondary: '#f5f5f7',
      cardBg: '#ffffff',
      textPrimary: '#444444', // Chrome-like font color
      textSecondary: '#4B5563',
      accentBlue: '#0071e3', // Apple blue
      accentPurple: '#0071e3', 
      accentTeal: '#0071e3',
      buttonBg: '#0071e3',
      buttonText: '#ffffff'
    },
    newyear: {
      primary: '#0c0c2d', // Deeper midnight blue for enhanced sophistication
      secondary: '#1e1e42', // Richer contrast blue
      cardBg: '#7777b5ff', // Warm champagne for better contrast
      textPrimary: '#ffffff', // Crisp white text
      textSecondary: '#d4af37', // Metallic gold for secondary text
      accentBlue: '#ffd700', // Vibrant gold for luxury
      accentPurple: '#e3e84aff', // Classic silver
      accentTeal: '#b8860b', // Darker goldenrod for depth
      buttonBg: '#ffd700', // Prominent gold buttons
      buttonText: '#0c0c2d', // Deep blue for contrast on gold
      // Enhanced fireworks colors
      fireworkGold: '#ffd700',
      fireworkSilver: '#c0c0c0',
      fireworkBronze: '#cd7f32',
      fireworkRed: '#ff2400', // Vibrant crimson red
      fireworkBlue: '#1e90ff', // Dodger blue for better visibility
      fireworkGreen: '#00ff7f', // Spring green for vibrancy
      fireworkPurple: '#da70d6', // Orchid purple for richness
      fireworkCyan: '#00ffff', // Bright cyan
      fireworkOrange: '#ffa500', // Added orange for more variety
      fireworkPink: '#ff69b4' // Added pink for celebration
    },
    cny: {
      primary: '#cc0000', // Traditional Chinese red
      secondary: '#990000', // Darker red for depth
      cardBg: '#fededeff', // Soft red-tinted white for cards
      textPrimary: '#222222', // Dark gray for primary text
      textSecondary: '#cc6600', // Traditional orange for secondary text
      accentBlue: '#ffcc00', // Bright golden yellow for accents
      accentPurple: '#e6b800', // Slightly darker gold for variety
      accentTeal: '#ffd700', // Metallic gold for highlights
      buttonBg: '#cc0000', // Traditional Chinese red for buttons
      buttonText: '#ffffff' // White text on buttons
    },
    thaipusam: {
      primary: '#8B4513', // Saddle brown for devotion
      secondary: '#A0522D', // Sienna for contrast
      cardBg: '#FFF8DC', // Cornsilk for cards
      textPrimary: '#000000', // Black text
      textSecondary: '#c18255ff', // Brown for secondary text
      accentBlue: '#FF8C00', // Dark orange for fire-walking
      accentPurple: '#FFA500', // Orange for devotion
      accentTeal: '#FFD700', // Gold for spiritual elements
      buttonBg: '#8B4513', // Brown buttons
      buttonText: '#ffffff' // White text on buttons
    },
    hariRayaAidilfitri: {
      primary: '#228B22', // Forest green for Eid
      secondary: '#006400', // Dark green for depth
      cardBg: '#F5FFFA', // Mint cream for cards
      textPrimary: '#000000', // Black text
      textSecondary: '#228B22', // Green for secondary text
      accentBlue: '#FFD700', // Gold for celebration
      accentPurple: '#FFA500', // Orange for festive mood
      accentTeal: '#FF6347', // Tomato red for joy
      buttonBg: '#228B22', // Green buttons
      buttonText: '#ffffff' // White text on buttons
    },
    labour: {
      primary: '#4169E1', // Royal blue for workers
      secondary: '#1E90FF', // Dodger blue for contrast
      cardBg: '#F0F8FF', // Alice blue for cards
      textPrimary: '#000000', // Black text
      textSecondary: '#4169E1', // Blue for secondary text
      accentBlue: '#FFD700', // Gold for recognition
      accentPurple: '#32CD32', // Lime green for productivity
      accentTeal: '#FF6347', // Tomato red for energy
      buttonBg: '#4169E1', // Blue buttons
      buttonText: '#ffffff' // White text on buttons
    },
    wesak: {
      primary: '#FFFFF0', // Ivory for purity
      secondary: '#F5F5DC', // Beige for serenity
      cardBg: '#FFFACD', // Lemon chiffon for cards
      textPrimary: '#000000', // Black text
      textSecondary: '#556B2F', // Dark olive green for secondary text
      accentBlue: '#DAA520', // Goldenrod for enlightenment
      accentPurple: '#B8860B', // Dark goldenrod for wisdom
      accentTeal: '#FFD700', // Gold for spiritual wealth
      buttonBg: '#556B2F', // Dark olive green buttons
      buttonText: '#ffffff' // White text on buttons
    },
    hariRayaHaji: {
      primary: '#8B0000', // Dark red for sacrifice
      secondary: '#A52A2A', // Brown for solemnity
      cardBg: '#FFF0F5', // Lavender blush for cards
      textPrimary: '#000000', // Black text
      textSecondary: '#8B0000', // Dark red for secondary text
      accentBlue: '#FFD700', // Gold for divine blessing
      accentPurple: '#FF8C00', // Dark orange for devotion
      accentTeal: '#FF6347', // Tomato red for sacrifice
      buttonBg: '#8B0000', // Dark red buttons
      buttonText: '#ffffff' // White text on buttons
    },
    merdeka: {
      primary: '#0033A0', // Deep blue for independence
      secondary: '#C8102E', // Red for courage
      cardBg: '#FFD700', // Gold for honor
      textPrimary: '#000000', // Black text
      textSecondary: '#0033A0', // Blue for secondary text
      accentBlue: '#FFD700', // Gold for national pride
      accentPurple: '#C8102E', // Red for bravery
      accentTeal: '#FFFFFF', // White for unity
      buttonBg: '#0033A0', // Blue buttons
      buttonText: '#ffffff' // White text on buttons
    },
    malaysia: {
      primary: '#CC0000', // Red for Malaysia flag
      secondary: '#0033A0', // Blue for Malaysia flag
      cardBg: '#FFD700', // Gold for Malaysia flag
      textPrimary: '#000000', // Black text
      textSecondary: '#009900', // Green for Malaysia flag
      accentBlue: '#FFD700', // Gold for unity
      accentPurple: '#009900', // Green for nature
      accentTeal: '#CC0000', // Red for passion
      buttonBg: '#0033A0', // Blue buttons
      buttonText: '#ffffff' // White text on buttons
    },
    deepavali: {
      primary: '#000000', // Black for night
      secondary: '#2F4F4F', // Dark slate gray for contrast
      cardBg: '#FFFFE0', // Light yellow for cards (oil lamps)
      textPrimary: '#FFD700', // Gold text for lights
      textSecondary: '#FFA500', // Orange for secondary text
      accentBlue: '#FFD700', // Gold for celebration
      accentPurple: '#FFA500', // Orange for festivity
      accentTeal: '#FF6347', // Tomato red for joy
      buttonBg: '#FF8C00', // Dark orange buttons
      buttonText: '#000000' // Black text on buttons
    },
    christmas: {
      primary: '#c41e3a', // Deep Christmas red
      secondary: '#8b0000', // Darker red for contrast
      cardBg: '#ffffff', // White cards for contrast
      textPrimary: '#006400', // Deep green for primary text
      textSecondary: '#8b0000', // Dark red for secondary text
      accentBlue: '#ffd700', // Gold for accents
      accentPurple: '#ffd700', // Gold for accents
      accentTeal: '#ffd700', // Gold for accents
      buttonBg: '#006400', // Deep green for buttons
      buttonText: '#ffffff' // White text on buttons
    },
    spring: {
      primary: '#0a1a0a',
      secondary: '#1a2a1a',
      cardBg: '#1a3a1a',
      textPrimary: '#ffffff',
      textSecondary: '#a5d6a7',
      accentBlue: '#0071e3', // Apple blue even in Spring theme
      accentPurple: '#0071e3',
      accentTeal: '#0071e3',
      buttonBg: '#0071e3',
      buttonText: '#ffffff'
    },
    summer: {
      primary: '#0a1a2a',
      secondary: '#1a2a3a',
      cardBg: '#1a3a4a',
      textPrimary: '#ffffff',
      textSecondary: '#81d4fa',
      accentBlue: '#0071e3', // Apple blue even in Summer theme
      accentPurple: '#0071e3',
      accentTeal: '#0071e3',
      buttonBg: '#0071e3',
      buttonText: '#ffffff'
    },
    halloween: {
      primary: '#1a0a2a',
      secondary: '#2a1a3a',
      cardBg: '#3a2a4a',
      textPrimary: '#ffffff',
      textSecondary: '#ffcc80',
      accentBlue: '#0071e3', // Apple blue even in Halloween theme
      accentPurple: '#0071e3',
      accentTeal: '#0071e3',
      buttonBg: '#0071e3',
      buttonText: '#ffffff'
    }
  };
  
  return themes[theme] || themes.default;
};

export const getThemeStyles = (theme) => {
  const colors = getThemeColors(theme);
  // Add fireworks-specific CSS variables for the new year theme
  if (theme === 'newyear') {
    return `
      :root {
        --primary-bg: ${colors.primary};
        --secondary-bg: ${colors.secondary};
        --card-bg: ${colors.cardBg};
        --text-primary: ${colors.textPrimary};
        --text-secondary: ${colors.textSecondary};
        --accent-blue: ${colors.accentBlue};
        --accent-purple: ${colors.accentPurple};
        --accent-teal: ${colors.accentTeal};
        --button-bg: ${colors.buttonBg || colors.accentBlue};
        --button-text: ${colors.buttonText || '#ffffff'};
        --firework-gold: ${colors.fireworkGold || colors.accentBlue};
        --firework-silver: ${colors.fireworkSilver || colors.accentPurple};
        --firework-bronze: ${colors.fireworkBronze || colors.accentTeal};
        --firework-red: ${colors.fireworkRed || '#ff0000'};
        --firework-blue: ${colors.fireworkBlue || '#0000ff'};
        --firework-green: ${colors.fireworkGreen || '#00ff00'};
        --firework-purple: ${colors.fireworkPurple || '#800080'};
        --firework-cyan: ${colors.fireworkCyan || '#00ffff'};
        --firework-orange: ${colors.fireworkOrange || '#ffa500'};
        --firework-pink: ${colors.fireworkPink || '#ffc0cb'};
      }
    `;
  }
  
  return `
    :root {
      --primary-bg: ${colors.primary};
      --secondary-bg: ${colors.secondary};
      --card-bg: ${colors.cardBg};
      --text-primary: ${colors.textPrimary};
      --text-secondary: ${colors.textSecondary};
      --accent-blue: ${colors.accentBlue};
      --accent-purple: ${colors.accentPurple};
      --accent-teal: ${colors.accentTeal};
      --button-bg: ${colors.buttonBg || colors.accentBlue};
      --button-text: ${colors.buttonText || '#ffffff'};
    }
  `;
};

const themeService = {
  getSeasonalTheme,
  getThemeColors,
  getThemeStyles
};

export default themeService;
